package fr.manyverse.app.presentation.dice3d

import kotlin.math.sqrt

/** Vecteur 3D minimal pour la géométrie des dés (x droite, y bas écran, z vers le spectateur). */
data class Vec3(val x: Float, val y: Float, val z: Float) {

    operator fun plus(other: Vec3) = Vec3(x + other.x, y + other.y, z + other.z)
    operator fun minus(other: Vec3) = Vec3(x - other.x, y - other.y, z - other.z)
    operator fun times(scalar: Float) = Vec3(x * scalar, y * scalar, z * scalar)
    operator fun unaryMinus() = Vec3(-x, -y, -z)

    infix fun dot(other: Vec3): Float = x * other.x + y * other.y + z * other.z

    infix fun cross(other: Vec3) = Vec3(
        y * other.z - z * other.y,
        z * other.x - x * other.z,
        x * other.y - y * other.x
    )

    val length: Float get() = sqrt(x * x + y * y + z * z)

    fun normalized(): Vec3 {
        val len = length
        return if (len < 1e-9f) ZERO else Vec3(x / len, y / len, z / len)
    }

    companion object {
        val ZERO = Vec3(0f, 0f, 0f)
    }
}
